import { Badge, Modal, Table } from "flowbite-react";
import {
  formatDateToDDMM,
  formatDateToYY,
  formatToReal,
  getCompanyAge,
  getImageURLScore,
  getLetterScore,
  getScoreLegends,
  isValidCNPJ,
  maskCEP,
  parseFoundationDate,
} from "../../utils/utils";
import TitleStripe from "../common/TitleStripe";
import QuadroSocietario from "../common/query/QuadroSocietario";
import NoOcurrence from "../common/query/NoOcurrence";

const QuadroSocietarioPlusQuery = ({ data, dataFull }) => {
  const probRaw = +data?.score?.score_pj?.probabilidade;

  return (
    <div>
      <TitleStripe className="mb-5">Quadro Societário Plus</TitleStripe>
      {data && !data?.mensagem ? (
        <QuadroSocietario
          socios={
            Array.isArray(data?.socio) ? data?.socio : [...[], data?.socio]
          }
        />
      ) : (
        <NoOcurrence />
      )}
    </div>
  );
};

export default QuadroSocietarioPlusQuery;
